import { AxiosInstance } from "axios";
import AssetCustomField from "../models/AssetCustomField";
import CustomFieldValues from "../models/CustomFieldValues";

import {CustomFieldUpdateResult} from "../models/AssetCustomFieldUpdate";

export default class AssetCustomFieldsApi {
    constructor(public readonly axiosInstance: AxiosInstance) {}

    fetchAssetCustomFields(assetTypeId: number, siteId: number): Promise<AssetCustomField[]> {
        const url = `/api/asset_custom_fields?assetTypeId=${assetTypeId}&siteId=${siteId}`;
        return this.axiosInstance.get(url).then(resp => resp.data.map(AssetCustomField.fromJson));
    }

    updateAssetCustomFields(siteId: number, assetId: number, customFieldId: number, value: any): Promise<CustomFieldUpdateResult> {
        const url = `/api/${siteId}/assets/${assetId}/customFields/${customFieldId}`;
        const body = { value };

        return this.axiosInstance.patch(url, body)
            .then(resp => {
                return CustomFieldUpdateResult.fromJson(resp.data);
            })
            .catch(err => {
                return new CustomFieldUpdateResult(false, [err.message || 'Unknown error']);
            });
    }

    async fetchCustomFieldsByCountItem(countItemId: string, assetId: number): Promise<CustomFieldValues[]> {
        const url = `/api/custom-fields?countItemId=${countItemId}&assetId=${assetId}`;

        try {
            const resp = await this.axiosInstance.get(url);
            return resp.data.map((data: any) => CustomFieldValues.fromJson(data));
        } catch (err) {
            console.error("Error fetching custom fields", err);
            return [];
        }
    }

    async fetchCustomFieldsByItem(itemId: string, assetId: number): Promise<CustomFieldValues[]> {
        const url = `/api/custom-fields-by-item?itemId=${itemId}&assetId=${assetId}`;

        try {
            const resp = await this.axiosInstance.get(url);
            return resp.data.map((data: any) => CustomFieldValues.fromJson(data));
        } catch (err) {
            console.error("Error fetching custom fields", err);
            return [];
        }
    }

    async postToCustomFieldTable(customFieldData: any): Promise<CustomFieldUpdateResult> {
        const url = `/api/custom-fields`;

        try {
            const resp = await this.axiosInstance.post(url, customFieldData);
            return CustomFieldUpdateResult.fromJson(resp.data);
        } catch (err: any) {
            return new CustomFieldUpdateResult(false, [err.message || 'Unknown error']);
        }
    }

    async updateCustomFieldTable(updateData: any): Promise<CustomFieldUpdateResult> {
        const url = `/api/custom-fields/`;
        const body = {
            itemId: updateData.itemId,
            countItemId: updateData.countItemId,
            assetId: updateData.assetId,
            customFields: updateData.customFields,
        };

        try {
            const resp = await this.axiosInstance.put(url, body);
            return CustomFieldUpdateResult.fromJson(resp.data);
        } catch (err : any) {
            return new CustomFieldUpdateResult(false, [err.message || 'Unknown error']);
        }
    }
}
